module.exports = __webpack_public_path__ + "img/demeter-logo.69a3bafc.png";